import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Toolbar, Typography } from "@mui/material";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface OcMassRoleToolbarProps {
  handleCancel: () => void;
  handleFinish: () => void;
  dialogTitle: string;
  disabled: boolean;
}

export const OcMassRoleToolbar: React.FC<OcMassRoleToolbarProps> = ({
  handleCancel,
  handleFinish,
  dialogTitle,
  disabled,
}) => {
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();

  return (
    <>
      {!isMobile && (
        <Toolbar sx={{}}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            flexGrow={1}
          >
            <Box>
              <Button
                id="my-hr-users-cancel-import-button"
                color="primary"
                variant="text"
                onClick={handleCancel}
                disabled={!disabled}
              >
                {t("MY_HR_INTERRUPT")}
              </Button>
            </Box>
            <Box>
              <Typography variant="h5">{dialogTitle}</Typography>
            </Box>
            <Box>
              <Button
                variant="contained"
                color="primary"
                onClick={handleFinish}
                disableElevation
                style={{ height: "36px" }}
                disabled={disabled}
              >
                {t("OC_FINISH")}
              </Button>
            </Box>
          </Box>
        </Toolbar>
      )}
      {isMobile && (
        <Toolbar>
          <Box width="100%">
            <Box height="16px" />
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
              flexGrow={1}
            >
              <Box>
                <Button
                  id="my-hr-users-cancel-import-button"
                  color="primary"
                  variant="text"
                  onClick={handleCancel}
                  disabled={!disabled}
                >
                  {t("MY_HR_INTERRUPT")}
                </Button>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleFinish}
                  disableElevation
                  style={{ height: "36px" }}
                  disabled={disabled}
                >
                  {t("OC_FINISH")}
                </Button>
              </Box>
            </Box>
            <Box height="16px" />
            <Box textAlign="center">
              <Typography variant="h5">{dialogTitle}</Typography>
            </Box>
            <Box height="16px" />
          </Box>
        </Toolbar>
      )}
    </>
  );
};

export default OcMassRoleToolbar;
